import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { HttpHelper } from '../helpers/http.helper';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ValidateTokenResponse, ValidateTokenRequest } from '../../login/models/tokenExpire.model';
import { ForgotPasswordRequest, ValidatePIN } from '../../login/models/forgotPassword.model';
import { ResetPasswordRequest } from '../../login/models/resetPassword.model';

@Injectable()
export class UserService {

    constructor(private _httpHelper: HttpHelper) {
    }

    // /**
    // *  This is Sync Method
    // *  Method to  server API urls and set into conif file
    // */
    // public async getCustomerAsync(softKey: string, compKey: string, accountNo: string): Promise<any> {
    //     let headers: Headers = new Headers();
    //     // headers.append(AuthConstants.EwpAccessTokenKey, SessionHelper.getAuthToken());
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "Customer/GetCustomerDetail?appKey=" + softKey + "&companyKey=" + compKey + "&accountNo=" + accountNo
    //     return await this._httpHelper.get(environment.AzureBaseUrl + url, reqOption).toPromise();
    // }

    /**
 *  This is Sync Method
 *  Method to  server API urls and set into conif file
 */
    public login(loginDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "user/login";
        return this._httpHelper.post(environment.APIBaseUrl + url, loginDc, reqOption);
    }

    public forgotPassword(forgotPasswordObj: ForgotPasswordRequest): Observable<string> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "user/forgotpassword";
        return this._httpHelper.post(environment.APIBaseUrl + url, forgotPasswordObj, reqOption);
    }

    public validatePin(pinObj: ValidatePIN): Observable<string> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "user/forgotpassword/validatepinsendemail";
        return this._httpHelper.post(environment.APIBaseUrl + url, pinObj, reqOption);
    }

    public validateToken(tokenObj: ValidateTokenRequest): Observable<ValidateTokenResponse> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "user/validatetoken";
        return this._httpHelper.post(environment.APIBaseUrl + url, tokenObj, reqOption);
    }

    public resetPassword(resetPasswordObj: ResetPasswordRequest): Observable<string> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "user/resetpassword";
        return this._httpHelper.post(environment.APIBaseUrl + url, resetPasswordObj, reqOption);
    }

}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/services/user.service.ts